module.exports = "<router-outlet></router-outlet>\n<app-toast-container></app-toast-container>\n\n"


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main